export const ROUTE_ACTION_TYPE = '@@Router/CALL_HISTORY_METHOD';
export const ROUTE_ACTION_TYPE_ABS = '@@Router/CALL_HISTORY_METHOD_ABS';
export const ROUTE_ACTION_TYPE_UP = '@@Router/CALL_HISTORY_METHOD_UP';
export const ROUTE_ACTION_SET_LINKS = '@@Router/SET_LINKS';
